import { useMemo } from 'react'

import { ConvertOpportunity } from './ConvertOpportunity'
import { DeleteOpportunity } from './DeleteOpportunity'
import { OpportunityCall } from './OpportunityCall'
import { ActionsType, ModalState, ModalType } from './types'

const modalTypes: Record<ModalType, React.ComponentType<ActionsType>> = {
  delete: DeleteOpportunity,
  call: OpportunityCall,
  convert: ConvertOpportunity
}

type Props = {
  leadId?: number
  modalState: ModalState
  setModalState: React.Dispatch<React.SetStateAction<ModalState>>
}

export const OpportunitiesActionsModals = ({
  leadId,
  modalState,
  setModalState
}: Props) => {
  const actionComponent = useMemo(() => {
    const Component = modalState.type ? modalTypes[modalState.type] : null

    return Component && modalState.opportunity ? (
      <Component
        open
        opportunity={modalState.opportunity}
        leadId={leadId}
        onCancel={() => setModalState({ opportunity: null, type: null })}
      />
    ) : null
  }, [modalState.type, modalState.opportunity, leadId, setModalState])

  return actionComponent
}
